import React from 'react'
import Menu from '../Menu'
import './Header.css'

const Header: React.FC = () => {
    return (
        <div className="container">
            <header className="header">
                <div className="header__logo">
                    <a href="/" rel="noreferrer nofollower">
                        Smart Contract Utilities
                    </a>
                </div>
                <Menu />
            </header>
        </div>
    )
}

export default Header
